var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page-view",attrs:{"h-100":""}},[_c('div',{class:_vm.titleWrapperClasses,style:(_vm.titleWrapperStyles)},[_vm._t("title")],2),_c('div',{class:_vm.contentWrapperClasses,style:(_vm.contentWrapperStyles),attrs:{"scrollable":""}},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }